import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { callApi } from '../../utils/callApi'
import { API_ROUTES } from '../../utils/apiRoutes'
import * as Actions from './actions'
import { ActionTypes, TMessageMethods } from './types'

function* getMessageMethodsWorker(action: ReturnType<typeof Actions.GetMessageMethods.request>) {
  // @ts-ignore
  const callBack = action.payload?.callBack
  let success = true
  let data = null
  
  try {
    data = (yield call(callApi, {
      method: 'get',
      path: API_ROUTES.messageMethods,
    })) as TMessageMethods[]
    
    yield put(Actions.GetMessageMethods.success(data))
  } catch (e) {
    success = false
    // @ts-ignore
    data = e?.data || e
    yield put(Actions.GetMessageMethods.error(`${data?.message || data}`))
  } finally {
    if (callBack) callBack(success, data)
  }
}


function* watchRequest() {
  yield takeEvery(ActionTypes.GET_MESSAGE_METHODS_R, getMessageMethodsWorker)
  
}

export default function* messageMethodsSaga() {
  yield all([fork(watchRequest)])
}